import { render, staticRenderFns } from "./generate.vue?vue&type=template&id=6c57bb94&scoped=true&"
import script from "./generate.vue?vue&type=script&lang=js&"
export * from "./generate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c57bb94",
  null
  
)

export default component.exports